// ======================================================================
// File Name       : AccountForm
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, FormControl, Col, Button } from 'react-bootstrap';
import { VALIDATE_TYPE } from '../../constants/index';
import FormControlValidate from '../../components/FormControlValidate';
import * as MessageTemplate from '../../constants/MessageTemplate';
import FormControlPassword from '../../components/FormControlPassword';
import { isSuperUser } from '../../utils/UserUtils';

class AccountForm extends React.Component {
  constructor() {
    super();
    this.validation = this.validation.bind(this);
  }
  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }

  render() {
    const { userInfo, handleChangeInfo, handleShowConfirm, isIntegrationUserEdit = false } = this.props;
    this.refsToValidate = [];
    return (
      <Form onSubmit={(e) => { e.preventDefault(); handleShowConfirm(); }} className='form-horizontal'>
        <Col className="padding-top-10 padding-left-15 padding-right-15">
          <Form.Group className="form-info" controlId="adminName">
            <Col as={Form.Label} sm={4}>
              名前<span className="required">&nbsp;(※)</span>
            </Col>
            <Col sm={8}>
              <FormControlValidate
                label="名前"
                ref={(ref) => {
                  if (ref) {
                    this.refsToValidate.push(ref);
                  }
                }}
                required
                name="userName"
                maxLength="40"
                onChange={handleChangeInfo}
                type="text"
                value={userInfo.userName}
              />
            </Col>
          </Form.Group>
          <Form.Group className="form-info" controlId="loginId">
            <Col as={Form.Label} sm={4}>
              ログインID<span className="required">&nbsp;(※)</span>
            </Col>
            <Col sm={8}>
              <FormControlValidate
                label="ログインID"
                ref={(ref) => {
                  if (ref) {
                    this.refsToValidate.push(ref);
                  }
                }}
                type="text"
                name="loginId"
                // #7483 START 
                maxLength="256"
                // #7483 END
                required
                // Step 7.0 #6 START
                // Step 11.0.0 START
                validateType = {isSuperUser(userInfo.displayUserType) ? VALIDATE_TYPE.LOGIN_ID_SU : VALIDATE_TYPE.USER_LOGIN_ID}
                // Step 11.0.0 END
                // Step 7.0 #6 END
                onChange={handleChangeInfo}
                value={userInfo.loginId}
              />
            </Col>
          </Form.Group>
          {/* Step 11.0.0 START */}
          {isSuperUser(userInfo.displayUserType) && (
            <FormControlPassword
              onChange={handleChangeInfo}
              value={userInfo.currentPassword}
              label="現在のパスワード"
              ref={(ref) => {
                if (ref) {
                  this.refsToValidate.push(ref);
                }
              }}
              name="currentPassword"
              labelSize={4}
              inputSize={8}
              maxLength="256"
              type={VALIDATE_TYPE.PASSWORD}
            />
          )}
          {/* Step 11.0.0 END */}
          <FormControlPassword
            onChange={handleChangeInfo}
            value={userInfo.password || ''}
            label="パスワード"
            ref={(ref) => {
              if (ref) {
                this.refsToValidate.push(ref);
              }
            }}
            name="password"
            labelSize={4}
            inputSize={8}
            type={VALIDATE_TYPE.PASSWORD}
            validateType={VALIDATE_TYPE.PASSWORD}
            minLength="10"
            maxLength="256"
            passStrType={userInfo.passStrType}
          />
          <FormControlPassword
            required={userInfo.password || false}
            onChange={handleChangeInfo}
            label="パスワード（確認）"
            ref={(ref) => {
              if (ref) {
                this.refsToValidate.push(ref);
              }
            }}
            name="passwordConfirm"
            value={userInfo.passwordConfirm}
            labelSize={4}
            inputSize={8}
            passwordConfirm={userInfo.password}
            type={VALIDATE_TYPE.PASSWORD_CONFIRM}
            maxLength="256"
            confirmPassword
          />
          {/* Step10.0.0 START */}
          {/* Step12.0.0 START */}
          {!isIntegrationUserEdit && (
            <Form.Group className="form-info" controlId="mailAddress">
              <Col as={Form.Label} sm={4}>
                メールアドレス
              </Col>
              <Col sm={8}>
                <FormControlValidate
                  type="text"
                  label="メールアドレス"
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                  name="mailAddress"
                  value={userInfo.mailAddress || ""}
                  validateType={VALIDATE_TYPE.EMAIL}
                  onChange={handleChangeInfo}
                  messageError={MessageTemplate.MSG_EMAIL_INVALID}
                  messageSuccess={MessageTemplate.MSG_EMAIL_VALID}
                />
              </Col>
            </Form.Group>
          )}
          {/* Step12.0.0 END */}
          {/* Step10.0.0 END */}
          <Form.Group className="form-info text-center">
            <Col sm={12} className="text-center margin-bottom-5">
              <Button type="button" variant="primary" type="submit" className="btn-96">
                登録
              </Button>
            </Col>
          </Form.Group>
        </Col>
      </Form>
    );
  }
}
export default AccountForm;
